import config from 'appConfig';
import getHeaders from 'Api/Helpers/getHeaders';
import { fetchJson } from './Helpers/fetch';
import { GET } from './Helpers/httpMethods';

export function getG2MSettings() {
  const url = `${config.meetingService.url}/rest/2/settings`;
  const options = {
    headers: getHeaders(true, 'Bearer'),
    method: GET
  };
  return fetchJson(url, options, 'json');
}
